module.exports = __webpack_public_path__ + "img/cpu-charge.0d100b62.svg";